import usePageMeta from '../lib/usePageMeta';
import PageHero from '../components/PageHero';
import { SITE } from '../data';

const PAGES = {
  privacy: {
    title: 'Privacy Policy',
    description: 'How Origo Private Limited collects, uses and protects your personal information.',
    sections: [
      ['Information we collect', 'We collect the details you give us when you contact us — such as your name, email address and project information — and basic, anonymised usage data about how the website is used.'],
      ['How we use it', 'We use your information to respond to enquiries, prepare proposals, deliver services and improve our website. We do not sell your personal data.'],
      ['Sharing', 'We only share data with trusted service providers who help us operate (for example hosting and email), and only where necessary or required by law.'],
      ['Cookies & analytics', 'We may use cookies and analytics tools to understand traffic and improve the site. You can control cookies in your browser settings.'],
      ['Your rights', `You may request access to, correction of or deletion of your personal data at any time by emailing ${SITE.email}.`],
      ['Security & retention', 'We apply reasonable technical and organisational measures to protect your data and keep it only as long as needed for the purposes above.'],
    ],
  },
  terms: {
    title: 'Terms of Service',
    description: 'The terms that apply when you use the Origo Private Limited website and services.',
    sections: [
      ['Use of this website', 'The content on this website is provided for general information. You agree not to misuse the site or attempt to disrupt its operation.'],
      ['Services', 'Specific services are governed by a written proposal or agreement that sets out scope, timeline, fees and deliverables.'],
      ['Intellectual property', 'Unless otherwise agreed in writing, ownership of final deliverables transfers to the client on receipt of full payment. We retain rights to our pre-existing tools and know-how.'],
      ['Payment', 'Fees, milestones and payment terms are defined in each agreement. Late payments may pause work until resolved.'],
      ['Limitation of liability', 'To the extent permitted by law, Origo Private Limited is not liable for indirect or consequential losses arising from use of the website or services.'],
      ['Contact', `Questions about these terms can be sent to ${SITE.email}.`],
    ],
  },
};

export default function Legal({ type }) {
  const page = PAGES[type];
  usePageMeta(page.title, page.description);

  return (
    <>
      <PageHero eyebrow="Legal" title={page.title} description={page.description} crumbs={[{ label: page.title }]} />
      <section className="section bg-white">
        <div className="container-x">
          <div className="mx-auto max-w-3xl space-y-10">
            <p className="text-sm text-slate-500">Last updated: October 2026. This is a template — have it reviewed by legal counsel before launch.</p>
            {page.sections.map(([h, t]) => (
              <div key={h} data-anim="up">
                <h2 className="font-display text-2xl font-bold text-ink">{h}</h2>
                <p className="mt-3 text-lg leading-relaxed text-slate-600">{t}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
